import { Injectable, InjectionToken } from '@angular/core';
import { dsEnums } from '@vectronic/openApi-admin';
import { UploadDevice } from '@vectronic/util';
import { from, map } from 'rxjs';

export const GPS_PLUS_X_PATH = new InjectionToken<string>('GPS_PLUS_X_PATH');

@Injectable({ providedIn: 'root' })
export class DeviceRegistrationTextService {
  // eslint-disable-next-line sonarjs/cognitive-complexity
  getDevicesFromRegistrationText(text: string): UploadDevice[] {
    const devices: UploadDevice[] = [];
    const lines = text.split('\n');
    const regex = /(\S+)/g;
    const idColumn = 0;
    const comTypeColumn = 2;
    for (let i = 0; i < lines.length; i++) {
      const device = {} as UploadDevice;
      const fields = lines[i].match(regex);
      if (fields === null || fields.length < 3 || isNaN(Number(fields[idColumn]))) continue;
      // device id
      device.idDevice = +fields[idColumn];
      // com type
      const comType = fields[comTypeColumn].toLowerCase();
      if (comType === 'iridium') device.comType = 'IRIDIUM';
      else if (comType === 'globalstar') device.comType = 'GLOBALSTAR';
      else if (comType === 'gsm-8bit') device.comType = 'GSM';
      else if (comType === 'gsm-7bit') device.comType = 'GSM';
      else if (comType === 'gsm-6bit') device.comType = 'GSM';
      else if (comType === 'iot') device.comType = 'NB_IOT';
      else if (comType === 'gsm') device.comType = 'GSM';
      else if (comType === 'no_communication') device.comType = 'NO_COMMUNICATION';
      else {
        device.comType = comType.toUpperCase() as dsEnums.ComType;
      }
      const comIdColumn = device.comType === 'GSM' ? 6 : 3;
      // com id
      if (
        fields.length > comIdColumn &&
        device.comType !== 'NB_IOT' &&
        device.comType !== 'NO_COMMUNICATION'
      )
        device.comIdTimeline = [
          {
            data: fields[comIdColumn],
            startDate: new Date().toISOString(),
          },
        ];
      devices.push(device);
    }
    return devices;
  }

  registrationFileUpload(file: File) {
    return from(file.text()).pipe(map((text) => this.getDevicesFromRegistrationText(text)));
  }
}
